import React from 'react';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, padding: '40px 20px', maxWidth: '900px', margin: '0 auto' }}>
        <h1 style={{ marginBottom: '8px', color: '#1a1a2e' }}>Privacy Policy</h1>
        <p style={{ color: '#666', marginBottom: '40px' }}>
          Effective Date: March 1, 2025 | Last Updated: January 15, 2026
        </p>

        <div style={{ lineHeight: '1.8', color: '#333' }}>
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>1. Introduction</h2>
            <p>
              ShowingBooker LLC ("ShowingBooker," "we," "us," or "our") is committed to protecting
              your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard
              your information when you use our property showing management platform and related services.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>2. Information We Collect</h2>

            <h3 style={{ fontSize: '1.1rem', marginTop: '16px', marginBottom: '8px' }}>2.1 Personal Information</h3>
            <p>When you create an account or use our services, we may collect:</p>
            <ul style={{ marginTop: '8px', paddingLeft: '24px' }}>
              <li>Name and contact information (email, phone number, address)</li>
              <li>Account credentials</li>
              <li>Professional information (real estate license, brokerage)</li>
              <li>Payment and billing information</li>
            </ul>

            <h3 style={{ fontSize: '1.1rem', marginTop: '16px', marginBottom: '8px' }}>2.2 Property and Tenant Information</h3>
            <p>To provide our services, we collect:</p>
            <ul style={{ marginTop: '8px', paddingLeft: '24px' }}>
              <li>Property addresses and details</li>
              <li>Tenant contact information (for notification purposes)</li>
              <li>Showing schedules and booking information</li>
              <li>Compliance documentation and records</li>
            </ul>

            <h3 style={{ fontSize: '1.1rem', marginTop: '16px', marginBottom: '8px' }}>2.3 Usage Data</h3>
            <p>We automatically collect:</p>
            <ul style={{ marginTop: '8px', paddingLeft: '24px' }}>
              <li>Device and browser information</li>
              <li>IP address and location data</li>
              <li>Usage patterns and preferences</li>
              <li>Log data and analytics</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>3. How We Use Your Information</h2>
            <p>We use collected information to:</p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Provide and maintain our services</li>
              <li>Process showing bookings and send notifications</li>
              <li>Generate compliance documentation and audit trails</li>
              <li>Process payments and manage subscriptions</li>
              <li>Send service-related communications</li>
              <li>Improve and personalize our services</li>
              <li>Ensure platform security and prevent fraud</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>4. Legal Basis for Processing</h2>
            <p>We process your information based on:</p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li><strong>Contract Performance:</strong> To fulfill our service agreement with you</li>
              <li><strong>Legitimate Interest:</strong> To improve services and ensure security</li>
              <li><strong>Legal Compliance:</strong> To meet regulatory requirements</li>
              <li><strong>Consent:</strong> For marketing communications (where applicable)</li>
            </ul>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>5. Information Sharing</h2>
            <p>We may share your information with:</p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li><strong>Service Providers:</strong> Third parties who help us operate our platform (payment processors, email services, cloud hosting)</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale</li>
              <li><strong>With Your Consent:</strong> When you authorize specific sharing</li>
            </ul>
            <p style={{ marginTop: '12px' }}>
              We do not sell your personal information to third parties for marketing purposes.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>6. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your
              information, including:
            </p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Encryption of data in transit and at rest</li>
              <li>Secure authentication mechanisms</li>
              <li>Regular security assessments</li>
              <li>Access controls and monitoring</li>
            </ul>
            <p style={{ marginTop: '12px' }}>
              However, no method of transmission over the Internet is 100% secure.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>7. Data Retention</h2>
            <p>We retain your information for as long as necessary to:</p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Provide our services</li>
              <li>Comply with legal obligations</li>
              <li>Resolve disputes and enforce agreements</li>
            </ul>
            <p style={{ marginTop: '12px' }}>
              Compliance-related records are retained for a minimum of 7 years to meet legal
              documentation requirements for real estate transactions.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>8. Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul style={{ marginTop: '12px', paddingLeft: '24px' }}>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Delete your information (subject to legal requirements)</li>
              <li>Object to or restrict certain processing</li>
              <li>Data portability</li>
              <li>Withdraw consent</li>
            </ul>
            <p style={{ marginTop: '12px' }}>
              To exercise these rights, contact us at david@codexdeus.com.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>9. California Privacy Rights (CCPA)</h2>
            <p>
              California residents have additional rights under the CCPA, including the right to know
              what personal information we collect, the right to delete, and the right to opt-out of
              the sale of personal information. We do not sell personal information.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>10. Cookies and Tracking</h2>
            <p>
              We use cookies and similar technologies to enhance your experience, analyze usage,
              and provide personalized content. You can manage cookie preferences through your
              browser settings.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>11. Children's Privacy</h2>
            <p>
              Our Service is not intended for individuals under 18 years of age. We do not knowingly
              collect personal information from children under 18. If we become aware of such
              collection, we will delete that information.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>12. Third-Party Links</h2>
            <p>
              Our Service may contain links to third-party websites. We are not responsible for
              the privacy practices of these sites. We encourage you to review their privacy policies.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>13. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of material
              changes by posting the new policy on this page and updating the "Last Updated" date.
              Continued use of the Service after changes constitutes acceptance of the updated policy.
            </p>
          </section>

          <section style={{ marginBottom: '32px', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
            <h2 style={{ color: '#1a1a2e', marginBottom: '16px' }}>Contact Information</h2>
            <p>
              For questions about this Privacy Policy or to exercise your rights:<br /><br />
              <strong>ShowingBooker LLC</strong><br />
              26565 Agoura Road, Suite 200<br />
              Calabasas, CA 91302 USA<br />
              Email: david@codexdeus.com<br /><br />
              Built by <a href="https://codexdeus.com" target="_blank" rel="noopener noreferrer" style={{ color: '#2d5a27' }}>CodexDeus</a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
